module.exports = __webpack_public_path__ + "static/img/characteristic-img-3.7ef08910.png";